export const walletShorter = (wallet) =>{
    if (wallet){
        return wallet.slice(0, 10) + "..." + wallet.slice(-10);
    } else {
        return null
    }
}